import { useSelector } from "react-redux"
import { useQuery } from "@tanstack/react-query"

import { API_ME_URL } from "../constants"
import { IErrorResponse, IUserResponse } from "../interface"
import { RootState } from "../../store/store"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"

export async function getUserInfo(token: string | null) {
  const response = await axios(`${API_ME_URL}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })

  if (checkIsFailure(response.status)) {
    throw new Error("Ошибка")
  }

  return response.data
}

export const useGetUserInfo = (enabled: boolean = true) => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useQuery<IUserResponse, IErrorResponse>({
    queryKey: ["user-info-data"],
    queryFn: () => getUserInfo(token),
    refetchOnWindowFocus: false,
    enabled: enabled && Boolean(token),
  })
}
